<template>
    <img class="step-by-step-slide"
       :style="data.styleRect"
       v-show="data.isShow"
       :src="`${bookInfoState.publicPath}/${data.imgSrc}`"
    >
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import cssvar from '@/scss/_variables.scss';

    const {getResizedAnnotationPos, styleAnnotationBtn} = useAnnotationHelper();

    export default {
        props: {
            annot:Object,
            sharedMeta:Object,
            pagenum:Number
        },
        setup(props, context) {

            const { parserState, readData} = useParser();
            const { bookInfoState} = useBookInfo();
            const { pageResizeState} = usePageResize();

            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    let resizedAnnotationPos = getResizedAnnotationPos(domPos);
                    let left = parseFloat(resizedAnnotationPos.left);
                    return {
                        ...resizedAnnotationPos,
                        ...styleAnnotationBtn(),
                        //TODO: see if the rule can be applied globally....
                        //there could be pixel displacement when authoring the tagging; attempt to align the left edge with the page image left side
                        ...{
                            transform: ( left < 0 ) ? `translate(${-1 * left}px, ${-1 * left}px)` : "none",
                            width: ( left < 0 ) ? "100%" : resizedAnnotationPos.width,
                            position:"absolute"
                        }
                    }
                }),
                currentPageStepProgress:computed(()=>{
                    return  bookInfoState.stepByStepProgress[props.pagenum];
                }),
                isShow:computed(()=>{

                    return (data.currentPageStepProgress &&
                            data.currentPageStepProgress[props.annot.id] !== undefined &&
                            data.currentPageStepProgress[props.annot.id] >= 0
                    );
                }),
                imgSrc:computed(()=>{
                    return (data.isShow) ? props.sharedMeta[props.annot.id]["imgSrcList"][data.currentPageStepProgress[props.annot.id]]: "";
                })
            });

            return {
                props,
                data,
                pageResizeState,
                bookInfoState,
                parserState,
            }

        }
    }

</script>


<style scoped lang="scss">


</style>